import type { MouseEvent } from 'react';
import { formatUtcDateTimeToTimeZone } from '@belong/common';
import { IconArrowDown } from '@belong/icons';
import { Text } from '@belong/ui';
import clsx from 'clsx';

type WorkCompletionPromptProps = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  partnerName?: string;
  scheduledStartOn?: string;
  scheduledEndOn?: string;
  timeZone?: string;
  customClassName?: string;
};

export function WorkCompletionPrompt({
  onClick,
  partnerName,
  scheduledStartOn,
  scheduledEndOn,
  timeZone,
  customClassName,
}: WorkCompletionPromptProps) {
  const startLabel = scheduledStartOn
    ? formatUtcDateTimeToTimeZone({
        dateTime: scheduledStartOn,
        // @ts-expect-error -- Legacy typecheck baseline; see docs/development/typecheck-baseline-followups.md. Refs: ARCH-56
        format: 'MMMM do, yyyy h:mm a',
        timeZone,
      })
    : '';
  const endLabel = scheduledEndOn
    ? formatUtcDateTimeToTimeZone({
        dateTime: scheduledEndOn,
        // @ts-expect-error -- Legacy typecheck baseline; see docs/development/typecheck-baseline-followups.md. Refs: ARCH-56
        format: 'h:mm a',
        timeZone,
      })
    : '';
  const dateLabel = endLabel ? `${startLabel} - ${endLabel}` : startLabel;

  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'flex w-full items-center justify-between gap-lg rounded border border-solid border-red bg-red-translucent-light p-sm text-left',
        customClassName,
      )}
    >
      <div>
        <Text fontWeight="semibold">
          Has {partnerName ?? 'The Pro'} Solved The Issue?
        </Text>
        <Text className="text-dark-gray" variant="p1">
          {dateLabel || 'Pending Visit Confirmation'}
        </Text>
      </div>

      <div className="flex gap-xs items-center">
        <Text fontWeight="semibold" className="text-navy" variant="p1">
          CONFIRM VISIT
        </Text>
        <IconArrowDown className="h-sm w-sm -rotate-90 [&>path]:fill-navy" />
      </div>
    </button>
  );
}
